import React from 'react';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="contenido-footer">
        <p>&copy; 2026 Martin Gwozdz. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
}

export default Footer;
